import {
    SETTING, USER_STEP
} from "../action-types";

const initState: any = {
    language: "zh",
    step: 0, // 进入页面渲染第几个tab
};
export default function settingReducer(state = initState, action: any) {
    switch (action.type) {
        /* 国际化 */
        case SETTING:
            return Object.assign({}, state, {language: action.payload});
        case USER_STEP:
            return Object.assign({}, state, {step: action.payload});
        default:
            return state;
    }
}
